import { getABNVariant } from '~/src/helpers/abn-tests';

const LEAD_GENERATION_VISIBILITY = {
    testName: 'hiding_lead_generation',
    variants: {
        HIDE: 'website_without_callback',
        SHOW: 'website_with_callback',
    },
};

export const isLeadGenerationHidden = (): boolean => getABNVariant(LEAD_GENERATION_VISIBILITY.testName) === LEAD_GENERATION_VISIBILITY.variants.HIDE;

export const pagesWithHiddenLeadGenerationInHeader = [
    '/_site/[city]/bundles/[[...alias]]',
    '/_site/[city]/internet',
    '/_site/[city]/internet/[alias]',
    '/_site/[city]/request',
];
